import { SET_CURRENT_USER } from "./types";
import { clearFormData } from "./formActions";
import { API_BASE_URL } from "../utils/constants";
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { notification } from "antd";

export const loginUser = loginRequest => dispatch => {
  axios
    .post(API_BASE_URL + "/auth/signin", loginRequest, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(res => {
      const token = res.data.accessToken;
      localStorage.setItem("jwtToken", token);
      setAuthToken(token);

      const decoded = jwt_decode(token);
      dispatch(setCurrentUser(decoded));

      notification.success({
        message: "Logged In",
        description: "You've successfully logged in!"
      });
    })
    .catch(err => {
      notification.error({
        message: "Login Error",
        description:
          err.response.data.status === 401
            ? "Your username or password is incorrect"
            : err.response.data.message
      });
    });
};

export const logoutUser = () => dispatch => {
  localStorage.removeItem("jwtToken");
  setAuthToken(false);
  dispatch(setCurrentUser({}));
  dispatch(clearFormData());

  notification.success({
    message: "Logged Out",
    description: "You've sucessfully logged out!"
  });
};

export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};
